var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { injectIntl } from 'react-intl';
import Input from '../../../../components/Deposit/TextInput';
import Single from '../../../../components/Deposit/Single';
import translate from '../../../../lib/utils/translate';

var Amount = function (_React$Component) {
  _inherits(Amount, _React$Component);

  function Amount() {
    _classCallCheck(this, Amount);

    return _possibleConstructorReturn(this, (Amount.__proto__ || Object.getPrototypeOf(Amount)).apply(this, arguments));
  }

  _createClass(Amount, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          values = _props.values,
          currency = _props.currency,
          intl = _props.intl,
          disableCustomAmount = _props.disableCustomAmount,
          disableAmountSelector = _props.disableAmountSelector;


      return React.createElement(
        'div',
        { className: 'amount-selector' },
        React.createElement(Single, {
          name: 'amount',
          disabled: disableAmountSelector,
          options: values.map(function (v) {
            return {
              value: v,
              label: intl.formatNumber(v, {
                style: 'currency',
                currency: currency,
                maximumSignificantDigits: 2,
                maximumFractionDigits: 2
              })
            };
          })
        }),
        React.createElement(Input, {
          pattern: '[0-9]*',
          className: 'custom-amount',
          name: 'amount',
          type: 'number',
          min: '0',
          disabled: disableCustomAmount,
          placeholder: translate({ id: 'label.enter-amount' }, intl)
        })
      );
    }
  }]);

  return Amount;
}(React.Component);

export default injectIntl(Amount);